let baseURL = 'https://file-service-api-prod-dot-turnkey-setup-246812.ew.r.appspot.com';

const currentURL = window.location.href;

// If the current URL includes 'acc-emdr-remote' or 'localhost', use the acceptance file service URL
// Else use the production file service URL
if (currentURL.includes('acc-emdr-remote') || currentURL.includes('localhost')) {
  baseURL = 'https://file-service-api-acc-dot-turnkey-setup-246812.ew.r.appspot.com';
}

export const FILE_SERVICE_URL = baseURL;
